import React, { Component } from "react";

class ChildStory extends Component {
  constructor(props) {
    super(props);
  }


  render() {
    const childStory = this.props.story;

    return (
      <div className={`child-story child-detail__item`}>
        <div className={`child-story__wrapper`}>
        {childStory.map((item, index) => {
          return (
            <p key={index} className={`child-story__content-${index}`}>
              {item}
            </p>
          );
        })}
        </div>
      </div>
    );
  }
}


export default ChildStory;
